import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ConfigurationService } from '../configuration/configuration.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BreadcrumbNavigationService } from '../breadcrumb-navigation/breadcrumb-navigation.service';
@Injectable({
    providedIn: 'root'
})
export class PreviewManagementService  {
    private _allowedRoutes: string[];
    constructor(
        private _router: Router,
        private _configService: ConfigurationService,
        private _localizeRouterService: LocalizeRouterService,
        private activatedRoute: ActivatedRoute
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this._configService.$globalSettings.subscribe((data) => {
            if (data) {
                const currentWebsite = this._configService.getSiteFromUrl();

                if (currentWebsite) {
                    const filteredItem = data.find((item) => item.site === currentWebsite.site);

                    if (filteredItem.enabled === false) {
                        this.activatedRoute.queryParams.subscribe((params) => {
                            const isNotForcePreview = params['forcePreview'] !== 'true' ? true : false;
                            this._configService.$isPreview.subscribe((data) => {
                                if (!data && isNotForcePreview) {
                                    const translatedPath = this._localizeRouterService.translateRoute('/' + 'page-not-found');
                                    this._router.navigate([translatedPath], { skipLocationChange: true });
                                    return false;
                                }
                            });
                        });
                    }
                }
            }
            return true;
        });

        return true;
    }
}
